import { usePathname } from "next/navigation";

import { reportAddToBagStats } from "@/api/requests/reportAtbStats";

type StatsType = {
  atbAction?: boolean;
  atbError?: string;
};

// grab bag area location for DataDog reporting
const getBagArea = (pathname: string): string => {
  const segments = pathname.split("/").filter(Boolean);

  if (segments.includes("p")) {
    return "pdp";
  }
  if (segments.includes("shop")) {
    return "shop-modal";
  }
  if (segments[0] === "dispensary-info") {
    return "dispensary";
  }
  // if bag area is null or undefined, used the path with / replaced with - and [] removed
  // allows us to find where the unknown errors are coming from and backfill the bag area later
  return pathname.replace(/\//g, "-").replace(/\[|\]/g, "");
};

export const useATBStats = () => {
  const pathname = usePathname() || "";
  const bagArea = getBagArea(pathname);

  return {
    reportATBStats: (stats: StatsType) => reportAddToBagStats(bagArea, stats),
  };
};
